import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { translations } from "./translations";

const LanguageContext = createContext(null);

function getByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc ? acc[key] : undefined), obj);
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ipps-lang") || "en");

  useEffect(() => {
    localStorage.setItem("ipps-lang", lang);
    document.documentElement.lang = lang === "th" ? "th" : "en";
  }, [lang]);

  const value = useMemo(() => {
    const dictionary = translations[lang] || translations.en;

    return {
      lang,
      setLang,
      toggleLanguage: () => setLang((prev) => (prev === "en" ? "th" : "en")),
      t: (path, fallback = "") => {
        const translated = getByPath(dictionary, path);
        if (translated === undefined || translated === null) {
          return fallback;
        }
        return translated;
      },
    };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error("useLanguage must be used within LanguageProvider");
  }
  return ctx;
}
